module.exports = __webpack_public_path__ + "static/img/6-en.eab756a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/6-en.png
// module id = vEWY
// module chunks = 1